// src/components/Home.js
import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Autocomplete, backdropClasses, Button, Collapse, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print'
import { useReactToPrint } from 'react-to-print';
// import NumPad from 'react-numpad';
import TableTabs from '../Components/TableTabs';
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import BeatLoader from "react-spinners/BeatLoader";
import CustomerDialog from '../Components/AddPetDialog';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { toast } from 'react-toastify';
import { BRAND } from '../constants/brand';
function Billing() {

  const TOP_NAV_OFFSET_PX = 50;

  const [isHovering, setIsHovering] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [bills, setBills] = useState([''])
  const [paymentMethod, setPaymentMethos] = useState('Cash')
  const [cash, setCash] = useState(0)
  const [open, setOpen] = useState(false);
  const [openDisc, setOpenDisc] = useState(false);
  const [discount, setDiscount] = useState(0)
  const [tempDisc, setTempDisc] = useState(0)
  const [invno, setInvNo] = useState()
  const [activeInvoiceNo, setActiveInvoiceNo] = useState('')
  const [isHoldBill, setIsHoldBill] = useState(false)
  const [holdBills, setHoldBills] = useState([])
  const [selectedHoldBill, setSelectedHoldBill] = useState(null)
  const [savingHoldBill, setSavingHoldBill] = useState(false)
  const [loadingHoldBill, setLoadingHoldBill] = useState(false)
  const [items, setItems] = useState([])
  const [expandedPackages, setExpandedPackages] = useState({})
  const [Returnitems, setReturnItems] = useState([])
  const [total, setTotal] = useState(0)
  const [metaData, setMetaData] = useState({ user: JSON.parse(sessionStorage.getItem(BRAND.sessionStorageKey))?.username,Total: total, Discount: discount,Method: paymentMethod, Amount: paymentMethod === 'Card' ? total : cash })
  const [loading,setLoading] = useState(false)
  const [userDetails,setUserDetails]  = useState([])
  const [treatmentItems, setTreatmentItems] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  
  const [showModal, setShowModal] = useState(false);
  const [modalItem, setModalItem] = useState(null);
  const [consumedUnits, setConsumedUnits] = useState('');
  const [modalMode, setModalMode] = useState(null); // 'customAmount' | 'oilAdd' | 'oilEdit'
  const [oilCategoryIds, setOilCategoryIds] = useState([]);
  
  const [animalData, setAnimalData] = useState([]);
  const [selectedPet, setSelectedPet] = useState(null);
  const [allItemsforBilling,setAllItemsForBilling] = useState([])
  const [loadingItems,setLoadingItems] = useState(true)
  const [customerName, setCustomerName] = useState('')
  const [vehicleNo, setVehicleNo] = useState('')
  const [customerInvoices, setCustomerInvoices] = useState([])
  const [model, setModel] = useState('')
  const [mileage, setMileage] = useState('')
  const [chassisNumber, setChassisNumber] = useState('')
  const [jobDoneBy, setJobDoneBy] = useState(null)
  const [technicians, setTechnicians] = useState([])
  const [showVehicleDetails, setShowVehicleDetails] = useState(false)
  const [lineDiscountDialog, setLineDiscountDialog] = useState({ open: false, item: null, value: 0 });
  const [holdModalOpen, setHoldModalOpen] = useState(false);
  const [holdSearch, setHoldSearch] = useState('');

  const fetchCustomerInvoices = () => {
    axios.get("https://serverdemo.ccsoftwares.com/billing/customerInvoices").then(res =>{
      setCustomerInvoices(res.data || [])
    }).catch(()=>{
    })
  }

  const fetchTechnicians = () => {
    axios.get("https://serverdemo.ccsoftwares.com/Employees/getEmployees").then(res => {
      const techs = (res.data || []).filter(emp => emp.role === 2);
      setTechnicians(techs);
    }).catch(() => {});
  }

  const fetchHoldBills = () => {
    axios.get("https://serverdemo.ccsoftwares.com/billing/getHoldBills").then(res => {
      setHoldBills(res.data || []);
    }).catch(() => {
      setHoldBills([]);
    });
  }

  const fetchBillingCategories = () => {
    axios.get("https://serverdemo.ccsoftwares.com/Category/getallcategoryBilling").then((res) => {
      const cats = res.data || [];
      const oils = cats
        .filter((c) => {
          const name = (c?.CategoryName || '').toString().trim().toLowerCase();
          return name === 'oil' || name === 'oils';
        })
        .map((c) => Number(c.CategoryID))
        .filter((id) => !Number.isNaN(id));
      setOilCategoryIds(oils);
    }).catch(() => {
      setOilCategoryIds([]);
    });
  }

  const [updateBillNo,setUpdateBillNo] = useState('');
  const  [updatedBillItems,setUpdatedBillItems] = useState([])
  const [updatedBillTotal,setUpdatedBillTotal] = useState(0)
  const [updateBillmetaData, setupdateBillMetaData] = useState({ user: JSON.parse(sessionStorage.getItem(BRAND.sessionStorageKey))?.username,Total: updatedBillTotal, Discount: 0,Method: 'Cash', Amount: updatedBillTotal })




  // Returns

  const [returnModalOpen, setReturnModalOpen] = useState(false);
  const [returnBillNo, setReturnBillNo] = useState('');
  const [returnBillDetails, setReturnBillDetails] = useState([]);
  const [returnLoading, setReturnLoading] = useState(false);

  const finalTotal = total - discount;

  const navigate = useNavigate();

  useEffect(() => {
    if(!sessionStorage.getItem(BRAND.sessionStorageKey)){
      setLoading(true)
      navigate("/Login")
    }
    else{
      setUserDetails(JSON.parse(sessionStorage.getItem(BRAND.sessionStorageKey)))
      //console.log(JSON.parse(sessionStorage.getItem(BRAND.sessionStorageKey)))
      setLoading(false)
      }
      codeRef.current.focus();


      const getAlBillableItems = () =>{
        setLoadingItems(true)
        axios.get("https://serverdemo.ccsoftwares.com/Item/getItemDetailsforBilling").then(res => {
          setAllItemsForBilling(res.data)
          setLoadingItems(false)
        }).catch(e => {
          ////console.log(e)
        })
      }

      getAlBillableItems()
      fetchCustomerInvoices()
      fetchTechnicians()
      fetchHoldBills()
      fetchBillingCategories()
  }, [])
  
  
  const ensureInvoiceNo = async () => {
    if (activeInvoiceNo) return activeInvoiceNo;

    const res = await axios.get('https://serverdemo.ccsoftwares.com/billing/getmaxshop1');
    const nextNo = res?.data?.[0]?.inv_no;
    if (!nextNo) throw new Error('Failed to generate invoice number');

    const now = new Date();
    const y = now.getFullYear();
    const m = formatTwoDigits(now.getMonth() + 1);
    const d = formatTwoDigits(now.getDate());
    const h = formatTwoDigits(now.getHours());

    setInvNo(nextNo);
    const newInvoiceNo = `${y}${m}${d}${h}DEMO${nextNo}`;
    setActiveInvoiceNo(newInvoiceNo);
    return newInvoiceNo;
  }

  const [returnBills, setReturnBills] = useState([''])

  const getBills = () =>{
    setLoading(true)


      axios.get('https://serverdemo.ccsoftwares.com/billing/getshop1Bills').then(res =>{
        // console.log(res.data)
        setReturnBills(res.data)

        
      })
   

  }

  const getLatestCustomerHistory = (vehicleVal, nameVal) => {
    const normalizedVehicle = (vehicleVal || '').trim().toLowerCase();
    const normalizedName = (nameVal || '').trim().toLowerCase();

    const matches = (customerInvoices || []).filter((inv) => {
      const invVehicle = (inv.Vehicle_no || '').trim().toLowerCase();
      const invName = (inv.Customer_name || '').trim().toLowerCase();
      if (normalizedVehicle && invVehicle === normalizedVehicle) return true;
      if (normalizedName && invName === normalizedName) return true;
      return false;
    });

    if (!matches.length) return null;

    return matches.reduce((latest, current) => {
      const latestDate = latest?.creation_date ? new Date(latest.creation_date) : null;
      const currentDate = current?.creation_date ? new Date(current.creation_date) : null;

      if (latestDate && currentDate) return currentDate > latestDate ? current : latest;
      if (currentDate) return current;
      if (latestDate) return latest;

      return (current.cikey || 0) > (latest?.cikey || 0) ? current : latest;
    }, matches[0]);
  };

  const applyCustomerHistory = (vehicleVal, nameVal) => {
    const match = getLatestCustomerHistory(vehicleVal, nameVal);
    if (match) {
      setCustomerName(match.Customer_name || nameVal || '');
      setVehicleNo(match.Vehicle_no || vehicleVal || '');
      setModel(match.model || '');
      setMileage(match.Milage ? match.Milage.toString() : '');
      setChassisNumber(match.chassis_number || '');
      setJobDoneBy(match.Job_Done_By != null ? parseInt(match.Job_Done_By) : null);
      setShowVehicleDetails(true);
    }
  }

  const clearVehicleDetails = () => {
    setModel('');
    setMileage('');
    setChassisNumber('');
    setJobDoneBy(null);
    setShowVehicleDetails(false);
  };


  const handleOpen = () => {
    if (!vehicleNo && !customerName) {
      toast.error('Enter Vehicle No or Customer Name before payment.');
      return;
    }
    setOpen(true);
    // setCash(0)
  };
  const handleOpenDisc = () => {
    setOpenDisc(true);
  };
  const handleClose = () => setOpen(false);
  const handleCloseDisc = () => setOpenDisc(false);

  const plusBtn = () => {
    setBills([...bills, ''])
  }


  const handleClick = () => {
    setDialogOpen(true);
  };

  const styles = {
    mainContainer :{
      backgroundColor : '#F5F5F5',
      width:'100%',
      // display : 'flex',
      justifyContent : 'center',
      margin : 10,
    },
    RightContainer : {
      backgroundColor :'white',
      // width : '60%',
      // width : '1050px',
      // height : '85vh',
      // padding : 10,
      // marginTop : -20,
      // boxShadow: '1px 1px 10px #1e1e1e',
      borderRadius: 5,
      // marginLeft : 20
    },
    sidePanel: {
      // backgroundColor : 'yellow',
      // marginRight : -10
    },
    sidepnlBtn: {
      // boxShadow: '1px 1px 10px #1e1e1e'
      borderRadius: 10
      , display: 'flex'
      , flexDirection: 'column',
      alignItems: 'center'
    },
    BillBtn: {
      boxShadow: '1px 1px 10px #1e1e1e',
      backgroundColor: isHovering ? 'white' : 'white',
      height: 50,
      borderTopLeftRadius: 10,
      borderBottomLeftRadius: 10

    },
    PlusBtn: {
      boxShadow: '1px 1px 10px #1e1e1e',
      width: 35,
      borderRadius: 10
    },
    deleteBtn: {
      width: 25,
      marginLeft: 20,

    },
    billTable:{
      backgroundColor :'white',
      // width : '490px',
      height : '62vh',
      padding : 10,
      // boxShadow: '1px 1px 10px #1e1e1e',
      borderRadius : 5,
      display : 'flex',
      flexDirection : 'column',
      borderTopLeftRadius : 0,
      justifyContent : 'space-between',
      overflow : 'auto',
      // marginLeft : 50,
      marginBottom : 20
      
    },
    paymentSelect: {
      width: '10wh',
      backgroundColor: 'white',
      padding: 10,
      boxShadow: '1px 1px 10px #1e1e1e',
      borderRadius: 5,
      marginTop: 20

    },
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      // width: 400,
      bgcolor: 'background.paper',
      border: '0px solid #000',
      boxShadow: 24,
      p: 4,
    }

    

  }



  useEffect(() => {

    let Total = 0.0;

    for (let i = 0; i < items.length; i++) {
      const linePrice = parseFloat(items[i].Price) * parseFloat(items[i].qty);
      const lineDiscount = parseFloat(items[i].lineDiscount || 0);
      Total = Total + Math.max(linePrice - lineDiscount, 0);
    }

    setTotal(Total);
    codeRef.current.focus();

  }, [items])


  // const addToBill = (e) => {
  //   //console.log(e)
  //   if (items.length > 0) {
  //     let found = false;

  //     items.forEach((item, i) => {
  //       if (e.name === item.name) {
  //         ////console.log(item.qty)
  //         item.qty += 1;
  //         found = true;
  //         const updateItem = [...items];
  //         setItems(updateItem);
  //       }
  //     });

  //     if (!found) {
  //       const updateItem = [...items, e];
  //       setItems(updateItem);
  //     }
  //   } else {
  //     const updateItem = [...items, e];
  //     setItems(updateItem);
  //   }

  //   codeRef.current.focus();

  // }

  const closeItemModal = () => {
    setShowModal(false);
    setModalItem(null);
    setConsumedUnits('');
    setModalMode(null);
  };

  const handleModalSubmit = () => {
    if (!modalItem) {
      return;
    }

    const parsedValue = parseFloat(consumedUnits);
    const isValidValue = consumedUnits && !Number.isNaN(parsedValue) && parsedValue > 0;
    const isCustomValueMode = modalMode === 'customAmount' || modalItem.ItemCategoryID === 5022;
    const isOilMode =
      modalMode === 'oilAdd' ||
      modalMode === 'oilEdit' ||
      oilCategoryIds.includes(Number(modalItem.ItemCategoryID));

    if (!isValidValue) {
      alert(
        isCustomValueMode
          ? 'Please enter a valid amount.'
          : isOilMode
            ? 'Please enter a valid liter amount.'
            : 'Please enter a valid number of units.'
      );
      return;
    }

    if (isCustomValueMode) {
      setItems((prevItems) => {
        const modalKey = modalItem.ItemID ?? modalItem._id ?? modalItem.name;
        const existingIndex = prevItems.findIndex((item) => {
          const itemKey = item.ItemID ?? item._id ?? item.name;
          return itemKey === modalKey;
        });

        if (existingIndex !== -1) {
          const updatedItems = [...prevItems];
          const existingItem = { ...updatedItems[existingIndex] };
          const currentPrice = parseFloat(existingItem.originalPrice) || 0;
          existingItem.originalPrice = (currentPrice + parsedValue).toFixed(2);
          existingItem.qty = 1;
          updatedItems[existingIndex] = existingItem;
          return updatedItems;
        }

        return [
          ...prevItems,
          {
            ...modalItem,
            qty: 1,
            Price: parsedValue.toFixed(2),
          },
        ];
      });

      closeItemModal();
      codeRef.current.focus();
      return;
    }

    if (isOilMode) {
      setItems((prevItems) => {
        const modalKey = modalItem.ItemID ?? modalItem._id ?? modalItem.name;
        const existingIndex = prevItems.findIndex((item) => {
          const itemKey = item.ItemID ?? item._id ?? item.name;
          return itemKey === modalKey;
        });

        const nextQty = parsedValue;

        if (existingIndex !== -1) {
          const updatedItems = [...prevItems];
          const existingItem = { ...updatedItems[existingIndex] };
          const currentQty = parseFloat(existingItem.qty || 0) || 0;

          existingItem.qty =
            modalMode === 'oilEdit' ? nextQty : (currentQty + nextQty);

          updatedItems[existingIndex] = existingItem;
          return updatedItems;
        }

        return [
          ...prevItems,
          {
            ...modalItem,
            qty: nextQty,
          },
        ];
      });

      closeItemModal();
      codeRef.current.focus();
      return;
    }

    const unitPrice = parseFloat(modalItem.Price);
    const totalPrice = unitPrice * parsedValue;

    // Add the real item to treatmentItems
    const realItem = {
      ...modalItem,
      qty: parsedValue,
      totalPrice: totalPrice.toFixed(2),
    };
    setTreatmentItems((prevTreatmentItems) => [...prevTreatmentItems, realItem]);

    // Create or update the "Treatment Charges" item
    let found = false;

    const updatedItems = items.map((item) => {
      if (item.name === 'miscellaneous') {
        found = true;
        const newPrice =
          parseFloat(item.Price) + totalPrice;
        return { ...item, Price: newPrice.toFixed(2) };
      }
      return item;
    });

    if (found) {
      setItems(updatedItems);
    } else {
      const newItem = {
        name: 'miscellaneous',
        qty: 1,
        Price: totalPrice.toFixed(2),
      };
      setItems([...items, newItem]);
    }

    closeItemModal();

    codeRef.current.focus();
  };



  const getEffectivePrice = (item) => {
    const original = parseFloat(item.sellingPrice ?? item.Price ?? item.sellingPrice ?? 0);
    const discounted = parseFloat(item.discountedPrice ?? 0);
    const hasDiscount = !Number.isNaN(discounted) && discounted > 0;
    return {
      originalPrice: Number.isNaN(original) ? 0 : original,
      effectivePrice: hasDiscount ? discounted : (Number.isNaN(original) ? 0 : original),
      discountedPrice: hasDiscount ? discounted : null,
    };
  };

  const formatPackageIncludes = (packageItems) => {
    if (!Array.isArray(packageItems) || packageItems.length === 0) return '';
    return packageItems
      .map((it) => {
        const name = it?.ItemName || it?.name || '';
        if (!name) return null;
        const qty = it?.Qty != null ? Number(it.Qty) : null;
        if (qty && qty !== 1) return `${name} x${qty}`;
        return name;
      })
      .filter(Boolean)
      .join(', ');
  };

  const formatLiters = (value) => {
    const num = parseFloat(value);
    if (!Number.isFinite(num)) return '';
    return num.toFixed(2);
  };

  const getBillLineKey = (line) => {
    if (!line) return 'line';
    if (line.isPackage) return `pkg-${line.PackageID ?? line.name ?? 'pkg'}`;
    return `itm-${line.ItemID ?? line.name ?? 'itm'}`;
  };

  const getItemRemarkLines = (item) => {
    const remark = item?.ItemRemark ?? item?.itemRemark ?? item?.remark ?? '';
    if (remark == null || remark === '') return [];
    return remark
      .toString()
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean);
  };

  const renderRemarkLines = (lines, styles) => {
    if (!lines.length) return null;
    if (lines.length === 1) {
      return <div style={styles.single}>{lines[0]}</div>;
    }
    return (
      <ul style={styles.list}>
        {lines.map((line, idx) => (
          <li key={`${idx}-${line}`} style={styles.listItem}>{line}</li>
        ))}
      </ul>
    );
  };

  const addToBill = (e) => {
      const priceInfo = getEffectivePrice(e);
      // console.log(e)
      const itemDetails = {
        ...e,
        name: e.name || e.ItemName,
        Price: priceInfo.effectivePrice,
        originalPrice: priceInfo.originalPrice,
        discountedPrice: priceInfo.discountedPrice,
        lineDiscount: e.lineDiscount || 0,
      };

      if (itemDetails.ItemCategoryID === 5022) {
        setModalMode('customAmount');
        setModalItem({ ...itemDetails, qty: 1 });
        setConsumedUnits('');
        setShowModal(true);
        return;
      }

      const isOilItem = oilCategoryIds.includes(Number(itemDetails.ItemCategoryID));
      if (isOilItem) {
        setModalMode('oilAdd');
        setModalItem({ ...itemDetails, qty: 1 });
        setConsumedUnits('');
        setShowModal(true);
        return;
      }

      if (items.length > 0) {
        let found = false;

        items.forEach((item) => {
          if (itemDetails.name === item.name) {
            item.qty += 1;
            found = true;
            const updateItem = [...items];
            setItems(updateItem);
          }
        });

        if (!found) {
          const updateItem = [...items, { ...itemDetails, qty: 1 }];
          setItems(updateItem);
        }
      } else {
        const updateItem = [...items, { ...itemDetails, qty: 1 }];
        setItems(updateItem);
      }

      codeRef.current.focus();
    
  };


  const resetBill = () => {

    items.forEach((item, i) => {
      ////console.log(item.qty)
      item.qty = 1;
      const updateItem = [...items];
      setItems(updateItem);
    });
    setIsHovering(false);
    setBills([''])
    setPaymentMethos('Cash')
    setCash(0)
    setOpen(false);
    setOpenDisc(false);
    setDiscount(0)
    setTempDisc(0)
    setInvNo()
    setActiveInvoiceNo('')
    setIsHoldBill(false)
    setSelectedHoldBill(null)
    setItems([])
    setExpandedPackages({})
    setTreatmentItems([])
    setCustomerName('')
    setVehicleNo('')
    setModel('')
    setMileage('')
    setChassisNumber('')
    setJobDoneBy(null)
    setShowVehicleDetails(false)
    setTotal(0)
    setMetaData({ Total: total, Discount: discount, user: JSON.parse(sessionStorage.getItem(BRAND.sessionStorageKey))?.userName, Method: paymentMethod, Amount: paymentMethod === 'Card' ? total : cash })
    codeRef.current.focus();

  }


  const printsRef = useRef()
  const ReturnprintsRef = useRef()

  const handlePrint = useReactToPrint({
    content: () => printsRef.current
  })

  const handleReturnPrint = useReactToPrint({
    content: () => ReturnprintsRef.current
  })


  const currentTime = new Date();
  const hours = formatTwoDigits(currentTime.getHours());
  const minutes = formatTwoDigits(currentTime.getMinutes());
  const seconds = formatTwoDigits(currentTime.getSeconds());

  function formatTwoDigits(value) {
    return value < 10 ? `0${value}` : value;
  }


  const returns = async () => {
    try {
      await getBills(); // Waits for getBills to complete
      // console.log(returnBills);
      setReturnModalOpen(true); // Executes after getBills is done
    } catch (error) {
      console.error("Error fetching bills:", error);
      // Handle the error as needed
    }
  };

  const handleReturnClose = () => {
    setReturnModalOpen(false);
    setReturnBillNo('');
    setReturnBillDetails(null);
    codeRef.current.focus();
  };
  
  const handleReturnSubmit = () => {
    if (!returnBillNo) {
      toast.error('Please enter a bill number.');
      return;
    }
    setReturnLoading(true);

    const data = {
      inv_no: returnBillNo,
    }

    // console.log(data)
    axios.post(`https://serverdemo.ccsoftwares.com/billing/getBill`, data)
      .then(res => {
        setReturnBillDetails(res.data);
        // console.log(res.data);
        setReturnLoading(false);
      })
      .catch(e => {
        toast.error('Bill not found.');
        setReturnLoading(false);
      });
  };

  const getReturnDetails = () =>{
    setReturnLoading(true);

    const data = {
      inv_no: returnBillNo,
    }
    axios.post(`https://serverdemo.ccsoftwares.com/billing/getBill`, data)
      .then(res => {
        setReturnBillDetails(res.data);
        // console.log(res.data);
        setReturnLoading(false);
      })
      .catch(e => {
        toast.error('Bill not found.');
        setReturnLoading(false);
      });
  }

  const openHoldBills = () => {
    fetchHoldBills();
    setHoldSearch('');
    setSelectedHoldBill(null);
    setHoldModalOpen(true);
  };

  const closeHoldBills = () => {
    setHoldModalOpen(false);
    setHoldSearch('');
    setSelectedHoldBill(null);
    codeRef.current.focus();
  };

  const normalizeName = (value) => (value || '').toString().trim().toLowerCase();

  const findBillableItemByName = (name, itemsList = allItemsforBilling) => {
    const key = normalizeName(name);
    if (!key) return null;
    return (itemsList || []).find((it) => normalizeName(it.ItemName || it.name) === key) || null;
  };

  const parsePackageIncludesLine = (includesText, itemsList = allItemsforBilling) => {
    const cleaned = (includesText || '').toString().trim();
    if (!cleaned) return [];

    return cleaned
      .split(',')
      .map((part) => part.trim())
      .filter(Boolean)
      .map((part) => {
        const match = part.match(/^(.*) x(\d+(?:\.\d+)?)$/);
        const itemName = match ? (match[1] || '').trim() : part;
        const qty = match ? parseFloat(match[2]) : 1;
        if (!itemName) return null;

        const matchedItem = findBillableItemByName(itemName, itemsList);
        return {
          ItemID: matchedItem?.ItemID,
          ItemCategoryID: matchedItem?.ItemCategoryID,
          ItemName: itemName,
          name: itemName,
          Qty: qty,
        };
      })
      .filter(Boolean);
  };

  const loadHoldBill = async (invNoOrRow) => {
    const inv_no = typeof invNoOrRow === 'string' ? invNoOrRow : invNoOrRow?.inv_no;
    if (!inv_no) {
      toast.error('Select a hold bill.');
      return;
    }

    const hasCurrent =
      (items && items.length > 0) || (treatmentItems && treatmentItems.length > 0);

    if (hasCurrent) {
      const confirmReplace = window.confirm('This will replace the current bill. Continue?');
      if (!confirmReplace) return;
    }

    setLoadingHoldBill(true);
    try {
      let itemsList = allItemsforBilling || [];
      if (!allItemsforBilling || allItemsforBilling.length === 0) {
        const itemsRes = await axios.get("https://serverdemo.ccsoftwares.com/Item/getItemDetailsforBilling");
        itemsList = itemsRes.data || [];
        setAllItemsForBilling(itemsList);
      }

      const res = await axios.post('https://serverdemo.ccsoftwares.com/billing/getHoldBill', { inv_no });
      const rows = res.data || [];
      if (!rows.length) {
        toast.error('Hold bill not found.');
        return;
      }

      const header = rows[0] || {};

      setActiveInvoiceNo(header.billNo || inv_no);
      setIsHoldBill(true);

      setCustomerName(header.Customer_name || '');
      setVehicleNo(header.Vehicle_no || '');
      setModel(header.model || '');
      setMileage(header.Milage != null ? header.Milage.toString() : '');
      setChassisNumber(header.chassis_number || '');
      setJobDoneBy(header.Job_Done_By != null ? parseInt(header.Job_Done_By) : null);
      setShowVehicleDetails(true);

      setDiscount(parseFloat(header.discount || 0));

      const restored = [];
      for (let idx = 0; idx < rows.length; idx++) {
        const row = rows[idx];
        const rawName = row?.item_name;
        if (!rawName) continue;

        const unitprice = parseFloat(row.unitprice || 0);
        const qty = parseFloat(row.qty || 0);
        const rowTotal = parseFloat(row.total || 0);

        const isIndented = typeof rawName === 'string' && rawName !== rawName.trim();
        const isIncludesLine = isIndented && unitprice === 0 && qty === 0 && rowTotal === 0;
        if (isIncludesLine) continue;

        const nextRow = rows[idx + 1];
        const nextRawName = nextRow?.item_name;
        const nextIsIncludesLine =
          typeof nextRawName === 'string' &&
          nextRawName !== nextRawName.trim() &&
          parseFloat(nextRow?.unitprice || 0) === 0 &&
          parseFloat(nextRow?.qty || 0) === 0 &&
          parseFloat(nextRow?.total || 0) === 0;

        const packageItems = nextIsIncludesLine
          ? parsePackageIncludesLine(nextRawName.trim(), itemsList)
          : null;

        if (nextIsIncludesLine) idx += 1;

        const trimmedName = rawName.toString().trim();
        const matched = findBillableItemByName(trimmedName, itemsList);

        restored.push({
          ...(matched || {}),
          name: trimmedName,
          ItemID: matched?.ItemID,
          ItemCategoryID: matched?.ItemCategoryID,
          stockId: matched?.stockId,
          Price: unitprice,
          qty: qty || 1,
          lineDiscount: parseFloat(row.lineItemDiscount || 0),
          isPackage: Boolean(packageItems && packageItems.length),
          packageItems: packageItems && packageItems.length ? packageItems : undefined,
          originalPrice: matched?.sellingPrice ?? unitprice,
          discountedPrice: matched?.discountedPrice ?? null,
        });
      }

      setTreatmentItems([]);
      setExpandedPackages({});
      setItems(restored);
      closeHoldBills();
    } catch (e) {
      console.error(e);
      toast.error('Failed to load hold bill.');
    } finally {
      setLoadingHoldBill(false);
    }
  };

  const holdCurrentBill = async () => {
    const individualItems = items.filter((item) => item.name !== 'Treatment Charges');
    const allItems = individualItems.concat(treatmentItems);

    if (!allItems.length) {
      toast.error('Add items before holding.');
      return;
    }

    if (!vehicleNo && !customerName) {
      toast.error('Enter Vehicle No or Customer Name before holding.');
      return;
    }

    setSavingHoldBill(true);
    let invoiceNoToUse = activeInvoiceNo;
    try {
      invoiceNoToUse = await ensureInvoiceNo();
    } catch (e) {
      console.error(e);
      toast.error('Failed to generate invoice number.');
      setSavingHoldBill(false);
      return;
    }

    const models = [];
    allItems.forEach((e) => {
      const lineDiscount = parseFloat(e.lineDiscount || 0);
      const packageItems = e?.isPackage ? (e.packageItems || []) : null;
      models.push({
        invoice_no: invoiceNoToUse,
        cashier: JSON.parse(sessionStorage.getItem(BRAND.sessionStorageKey))?.username,
        bill_date: `${year}-${month}-${day}`,
        bill_time: `${hours}:${minutes}`,
        product_name: e.name,
        qty: parseFloat(e.qty) || parseFloat(e.units) || 1,
        unit_price: parseFloat(e.Price) || parseFloat(e.totalPrice) || 0,
        lineItemDiscount: lineDiscount,
        is_package: e?.isPackage ? 1 : 0,
        package_items: packageItems,
        gross_total: metaData.Total,
        discount: metaData.Discount,
        net_total: metaData.Total - metaData.Discount,
        paymentMethod: metaData.Method,
        cash_amount: metaData.Amount,
        Balance: metaData.Amount - (metaData.Total - metaData.Discount),
        Item_ID: e.ItemID,
        product_category_id: e.ItemCategoryID,
        store: BRAND.name,
        stockid: e.stockId,
      });
    });

    const billingData = {
      inv_no: invoiceNoToUse,
      username: JSON.parse(sessionStorage.getItem(BRAND.sessionStorageKey))?.username,
      inv_date: `${year}-${month}-${day}`,
      gross_total: metaData.Total,
      discount: metaData.Discount,
      net_total: finalTotal,
      shop: BRAND.name,
      paymentMethod: metaData.Method,
      holdBill: 1,
      items: models,
    };

    const customerInvoicePayload = {
      inv_no: invoiceNoToUse,
      customer_name: customerName,
      vehicle_no: vehicleNo,
      bill_date: `${year}-${month}-${day}`,
      model,
      mileage: mileage ? parseInt(mileage) : null,
      chassis_number: chassisNumber,
      job_done_by: jobDoneBy,
    };

    const customerInvoicePromise = (customerName || vehicleNo || model || mileage || chassisNumber || jobDoneBy)
      ? axios.post('https://serverdemo.ccsoftwares.com/billing/customerInvoice', customerInvoicePayload)
      : Promise.resolve();

    try {
      await Promise.all([
        axios.post('https://serverdemo.ccsoftwares.com/billing/saveShop1Invoice', billingData),
        customerInvoicePromise,
      ]);
      fetchCustomerInvoices();
      fetchHoldBills();
      toast.success(`Bill held: ${invoiceNoToUse}`);
      resetBill();
    } catch (e) {
      console.error(e);
      toast.error('Failed to hold bill.');
    } finally {
      setSavingHoldBill(false);
    }
  };



  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = formatTwoDigits(currentDate.getMonth() + 1); // Months are zero-based, so we add 1
  const day = formatTwoDigits(currentDate.getDate());
  const hour = formatTwoDigits(currentDate.getHours());
  const minute = formatTwoDigits(currentDate.getMinutes());
  const second = formatTwoDigits(currentDate.getSeconds());
  const invoiceNumber = activeInvoiceNo || '';
  const printableItems = [
    ...items.filter((item) => item.name !== 'Treatment Charges'),
    ...treatmentItems
  ];
  const customerNameOptions = Array.from(new Set((customerInvoices || []).map(i => i.Customer_name).filter(Boolean)));
  const vehicleNoOptions = Array.from(new Set((customerInvoices || []).map(i => i.Vehicle_no).filter(Boolean)));
  const holdBillsQuery = (holdSearch || '').trim().toLowerCase();
  const filteredHoldBills = (holdBills || []).filter((hb) => {
    if (!holdBillsQuery) return true;
    const fields = [hb?.inv_no, hb?.Vehicle_no, hb?.Customer_name, hb?.model];
    return fields.some((field) =>
      (field || '').toString().toLowerCase().includes(holdBillsQuery)
    );
  });
  const lineDiscountTotal = items.reduce((sum, itm) => sum + (parseFloat(itm.lineDiscount || 0)), 0);
  const priceDiscountTotal = items.reduce((sum, itm) => {
    const qty = parseFloat(itm.qty) || parseFloat(itm.units) || 1;
    const original = parseFloat(itm.originalPrice ?? itm.Price ?? 0);
    const effective = parseFloat(itm.discountedPrice ?? itm.Price ?? 0);
    const diff = original - effective;
    return diff > 0 ? sum + diff * qty : sum;
  }, 0);
  const totalDiscountSum = lineDiscountTotal + priceDiscountTotal + parseFloat(metaData?.Discount || 0);
  const selectedTechnician = technicians.find(t => t.empid === jobDoneBy) || null;
  const PRINT_BILL_BODY_FONT_SIZE_PX = 12;

  const printTheme = {
    page: {
      width: '210mm',
      minHeight: '297mm',
      padding: '16mm',
      paddingBottom: '31mm',
      backgroundColor: '#fff',
      fontFamily: 'Consolas, monospace',
      color: '#000',
      display: 'flex',
      flexDirection: 'column'
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '12mm'
    },
    brandBlock: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      maxWidth: '60%'
    },
    brandName: { fontSize: '18px', letterSpacing: '0.5px' },
    brandMeta: { fontSize: '10px', color: '#000', lineHeight: 1.35 },
    metaBlock: {
      minWidth: '38%',
      background: 'transparent',
      color: '#000',
      padding: '12px 14px',
      borderRadius: 0,
      boxShadow: 'none',
      border: '1px dashed #000',
      fontSize: '10px',
      fontFamily: 'Consolas, monospace',
    },
    metaRow: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '6px 0',
      borderBottom: '1px dashed #000'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      backgroundColor: 'white',
      boxShadow: 'none',
      borderRadius: 0,
      border: 'none',
      overflow: 'hidden',
      marginBottom: '12mm',
      fontFamily: 'Consolas, monospace',
    },
    th: {
      background: 'transparent',
      color: '#000',
      textAlign: 'left',
      fontSize: '10px',
      padding: '10px',
      letterSpacing: '0.4px',
      fontWeight: 'normal',
      border: 'none'
    },
    td: {
      padding: '10px',
      fontSize: '10px',
      border: 'none'
    },
    rowAlt: { backgroundColor: 'transparent' },
    totals: {
      marginTop: '4mm',
      width: '40%',
      alignSelf: 'flex-end',
      backgroundColor: 'white',
      borderRadius: 0,
      boxShadow: 'none',
      padding: '12px',
      border: '1px dashed #000'
    },
    totalRow: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '8px 0',
      fontSize: '10px',
      borderBottom: '1px dashed #000'
    },
    grandTotal: { fontSize: '12px', color: '#000' },
    payment: {
      marginTop: '4mm',
      display: 'flex',
      gap: '8px',
      flexWrap: 'wrap'
    },
    paymentCard: {
      flex: '1 1 180px',
      backgroundColor: 'white',
      padding: '10px 12px',
      borderRadius: '10px',
      boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
      fontSize: '10px'
    },
    footer: {
      position: 'fixed',
      bottom: '27mm',
      left: '16mm',
      right: '16mm',
      width: 'calc(100% - 32mm)',
      paddingTop: '6mm',
      fontSize: '9px',
      color: '#000',
      textAlign: 'center',
      lineHeight: 1.6
    },
    badge: {
      display: 'inline-block',
      padding: '8px 12px',
      backgroundColor: 'transparent',
      color: '#000',
      borderRadius: 0,
      border: '1px dashed #000',
      fontSize: '10px',
      marginBottom: '8px',
      letterSpacing: '0.2px'
    },
    customerInfo: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '10px',
      backgroundColor: 'white',
      fontFamily: 'Consolas, monospace',
      padding: '12px',
      borderRadius: 0,
      boxShadow: 'none',
      marginBottom: '10mm',
      fontSize: '10px'
    },
    customerLabel: { color: '#000', marginBottom: '2px' },
    customerValue: { color: '#000', wordBreak: 'break-word' }
  };
  
  // ////console.log(metaData)

  useEffect(() => {
    setMetaData({ Total: total, Discount: discount, user: JSON.parse(sessionStorage.getItem(BRAND.sessionStorageKey))?.userName, Method: paymentMethod, Amount: paymentMethod === 'Card' ? total : cash })
    // codeRef.current.focus();
  }, [bills, cash, discount, paymentMethod, total])

  const toPrint = async () => {
    setLoading(true);

    const individualItems = items.filter(item => item.name !== 'Treatment Charges');
    const allItems = individualItems.concat(treatmentItems);
    const models = [];

    let invoiceNoToUse = activeInvoiceNo;
    try {
      invoiceNoToUse = await ensureInvoiceNo();
    } catch (e) {
      console.error(e);
      toast.error('Failed to generate invoice number.');
      setLoading(false);
      return;
    }

    allItems.forEach((e, i) => {
      const lineDiscount = parseFloat(e.lineDiscount || 0);
      const packageItems = e?.isPackage ? (e.packageItems || []) : null;
      const model = {
        invoice_no: invoiceNoToUse,
        cashier: JSON.parse(sessionStorage.getItem(BRAND.sessionStorageKey))?.username,
        bill_date: `${year}-${month}-${day}`,
        bill_time: `${hours}:${minutes}`,
        product_name: e.name,
        qty: parseFloat(e.qty) || parseFloat(e.units) || 1,
        unit_price: parseFloat(e.Price) || parseFloat(e.totalPrice) || 0,
        lineItemDiscount: lineDiscount,
        is_package: e?.isPackage ? 1 : 0,
        package_items: packageItems,
        gross_total: metaData.Total,
        discount: metaData.Discount,
        net_total: metaData.Total - metaData.Discount,
        paymentMethod: metaData.Method,
        cash_amount: metaData.Amount,
        Balance: metaData.Amount - (metaData.Total - metaData.Discount),
        Item_ID: e.ItemID, // Use e._id if available, otherwise e.ItemID
        product_category_id: e.ItemCategoryID,
        store: BRAND.name,
        stockid : e.stockId
      };
      models.push(model);
    });
    const billingData = {
      inv_no: invoiceNoToUse,
      username: JSON.parse(sessionStorage.getItem(BRAND.sessionStorageKey))?.username,
      inv_date: `${year}-${month}-${day}`,
      gross_total: metaData.Total,
      discount: metaData.Discount,
      net_total: finalTotal,
      shop: BRAND.name,
      paymentMethod: metaData.Method,
      holdBill: 0,
      items: models, // Include the models array here
    };
    const customerInvoicePayload = {
      inv_no: invoiceNoToUse,
      customer_name: customerName,
      vehicle_no: vehicleNo,
      bill_date: `${year}-${month}-${day}`,
      model,
      mileage: mileage ? parseInt(mileage) : null,
      chassis_number: chassisNumber,
      job_done_by: jobDoneBy
    };
    const stockUpdateItems = [];
    allItems.forEach((e, i) => {
      const baseQty = parseFloat(e.qty) || parseFloat(e.units) || 1;

      if (e?.isPackage && Array.isArray(e.packageItems) && e.packageItems.length) {
        e.packageItems.forEach((pi) => {
          const itemQty = parseFloat(pi?.Qty ?? 1) || 1;
          const name = pi?.ItemName || pi?.name;
          if (!name) return;
          const itemId = pi?.ItemID;
          const itemCategoryId = pi?.ItemCategoryID;
          if (itemId == null || itemCategoryId == null) return;
          stockUpdateItems.push({
            itemId,
            itemCategoryId,
            itemName: name,
            qty: Math.max(baseQty * itemQty, 0),
          });
        });
        return;
      }

      const itemId = e?._id || e?.ItemID;
      const itemCategoryId = e?.ItemCategoryID;
      if (itemId == null || itemCategoryId == null || !e?.name) return;
      stockUpdateItems.push({
        itemId, // Use e._id if available, otherwise e.ItemID
        itemCategoryId,
        itemName: e.name,
        qty: baseQty,
      });
    });
    const stockUpdateData = {
      items: stockUpdateItems,
    };

      const customerInvoicePromise = (customerName || vehicleNo || model || mileage || chassisNumber || jobDoneBy)
        ? axios.post('https://serverdemo.ccsoftwares.com/billing/customerInvoice', customerInvoicePayload)
        : Promise.resolve();

    try {
      await Promise.all([
        axios.post('https://serverdemo.ccsoftwares.com/billing/saveShop1Invoice', billingData),
        axios.post('https://serverdemo.ccsoftwares.com/stock/BillShop1Items', stockUpdateData),
        customerInvoicePromise,
      ]);
      setRefreshKey((prevKey) => prevKey + 1);
      fetchCustomerInvoices();
      fetchHoldBills();
      handlePrint();
      resetBill();
    } catch (e) {
      console.error(e);
      toast.error('Failed to save/print bill.');
    } finally {
      setLoading(false);
    }
  }
  const toReturnPrint = () => {
    // console.log(returnBillDetails)
    const Updatedmodels = [];

    returnBillDetails.forEach((e, i) => {
        const model = {
          invdetails_key:e.invdetails_key,
          invoice_no: e.inv_no,
          bill_date: `${year}-${month}-${day}`,
          bill_time: `${hours}:${minutes}`,
          qty: parseInt(e.returnQty) >=0 ? parseInt(e.returnQty) :  parseInt(e.qty),
          gross_total: (parseInt(e.returnQty) >=0 ? parseInt(e.returnQty) :  parseInt(e.qty)) * parseFloat(e.unitprice),
          unitPrice : e.unitprice,
          item_name :e.item_name
        };
        Updatedmodels.push(model);
        setUpdateBillNo(e.inv_no)
      });

      setUpdatedBillItems(Updatedmodels)

      const calculatedTotal = Updatedmodels.reduce((acc, item) => acc + item.gross_total, 0);

      // console.log(Updatedmodels)
      setUpdatedBillTotal(calculatedTotal)

      // console.log(calculatedTotal)
    

      axios.post('https://serverdemo.ccsoftwares.com/billing/updateBill',Updatedmodels).then((res) =>{
        // console.log(res)
        handleReturnPrint()

      }).catch(e =>{
      })

  
    // resetBill()

  }
  const UpdatedTheDeleteBill = () => {
    // Check if returnBillNo is not empty (i.e., ensure a valid invoice is selected)
    if (!returnBillNo) {
      // console.log('Deletion cancelled / Select An Invoice');
      alert('Please select an invoice to delete');
      return; // Exit the function if no invoice number is selected
    }
  
    const data = {
      inv_no: returnBillNo,
    };
  
    // Show confirmation dialog
    const confirmDelete = window.confirm('Are you sure you want to delete this bill?');
  
    if (confirmDelete) {
      // console.log(data);
      axios
        .post('https://serverdemo.ccsoftwares.com/billing/DeleteInvoices', data)
        .then((res) => {
          alert('Deleted');
          setReturnModalOpen(false)
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      console.log('Deletion cancelled');
    }
  };

  const changeQtyMinus = (e) => {
    if (items.length > 0) {
      let found = false;

      items.forEach((item, i) => {
        if (e.name === item.name) {
          ////console.log(item.qty)
          item.qty -= 1;
          found = true;
          const updateItem = [...items];
          setItems(updateItem);
        }
      });

      if (!found) {
        const updateItem = [...items, e];
        setItems(updateItem);
      }
    } else {
      const updateItem = [...items, e];
      setItems(updateItem);
    }

  }




  const changeQtyPlus = (e) => {
    if (items.length > 0) {
      let found = false;

      items.forEach((item, i) => {
        if (e.name === item.name) {
          ////console.log(item.qty)
          item.qty += 1;
          found = true;
          const updateItem = [...items];
          setItems(updateItem);
        }
      });

      if (!found) {
        const updateItem = [...items, e];
        setItems(updateItem);
      }
    } else {
      const updateItem = [...items, e];
      setItems(updateItem); 
    }

  }

  const openOilEditModal = (item) => {
    if (!item) return;
    setModalMode('oilEdit');
    setModalItem({ ...item });
    const currentQty = item?.qty != null ? parseFloat(item.qty) : NaN;
    setConsumedUnits(Number.isFinite(currentQty) ? String(currentQty) : '');
    setShowModal(true);
  };

  const updateLineDiscount = (itemName, value) => {
    const discountValue = Math.max(parseFloat(value) || 0, 0);
    const updatedItems = items.map((item) =>
      item.name === itemName ? { ...item, lineDiscount: discountValue } : item
    );
    setItems(updatedItems);
  };

  const openLineDiscountDialog = (item) => {
    setLineDiscountDialog({ open: true, item, value: item.lineDiscount || 0 });
  };

  const closeLineDiscountDialog = () => {
    setLineDiscountDialog({ open: false, item: null, value: 0 });
  };

  const saveLineDiscount = () => {
    if (lineDiscountDialog.item) {
      updateLineDiscount(lineDiscountDialog.item.name, lineDiscountDialog.value);
    }
    closeLineDiscountDialog();
  };

  const addDiscount = () => {
    setDiscount(parseInt(discount) + parseInt(tempDisc))
    handleCloseDisc()

  }

  const deleteItem = (e) => {
    setItems(items.filter(item => item.name !== e))
    if(items.length-1 < 1){
      setDiscount(0)
    }
    codeRef.current.focus();
  }



  const makeReturn = (billDetails) => {

    // console.log(billDetails);

   const shop = JSON.parse(sessionStorage.getItem(BRAND.sessionStorageKey))?.shop;

     axios.post('https://serverdemo.ccsoftwares.com/billing/return1',billDetails).then((res) => {
       toast.error('Return Successful');
       getReturnDetails()
       codeRef.current.focus();
     });
   



  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      allItemsforBilling.map((e,i) => {
        //console.log("ItemId",e.ItemID)
        //console.log("codeRef.current.value",codeRef.current.value)
        if(parseInt(e.barcode) === parseInt(codeRef.current.value)){
          //console.log(e)
          const itemDetails = {
            ...e,
            name: e.ItemName,
            Price: e.sellingPrice
          };
          addToBill(itemDetails)
          codeRef.current.value = "";
        }
        
      })

    }
  };


  const codeRef = useRef(null);

  const handleQtyChange = (index, newQty) => {
    // Ensure the newQty is within the bounds (1 to e.qty)
    const updatedQty = Math.min(Math.max(newQty, 0), returnBillDetails[index].qty); 
    // console.log(updatedQty)
    // Update the returnBillDetails array (use a copy of the array to trigger re-render)
    setReturnBillDetails(prevDetails => {
      const updatedDetails = [...prevDetails];
      updatedDetails[index] = {
        ...updatedDetails[index],
        returnQty: updatedQty,  // Store the updated return quantity
      };
      return updatedDetails;
    });

  };
  
  const isCustomValueItem = modalMode === 'customAmount' || modalItem?.ItemCategoryID === 5022;
  const isOilModal =
    modalMode === 'oilAdd' ||
    modalMode === 'oilEdit' ||
    oilCategoryIds.includes(Number(modalItem?.ItemCategoryID));
  const modalNumericValue = parseFloat(consumedUnits);
  const hasModalNumericValue = consumedUnits && !Number.isNaN(modalNumericValue) && modalNumericValue > 0;
  const modalUnitPrice = parseFloat(modalItem?.Price || 0);
  const modalLineTotal = hasModalNumericValue ? modalNumericValue * modalUnitPrice : null;

  return (
    <>
    <Modal
      open={lineDiscountDialog.open}
      onClose={closeLineDiscountDialog}
    >
      <Box sx={{ ...styles.style, width: 320 }}>
        <Typography variant="h6" component="h2">
          Line Discount
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {lineDiscountDialog.item?.name || ''}
        </Typography>
        <TextField
          fullWidth
          type="number"
          label="Discount (Rs.)"
          variant="standard"
          value={lineDiscountDialog.value}
          onChange={(e) => setLineDiscountDialog((prev) => ({ ...prev, value: e.target.value }))}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 3 }}>
          <Button onClick={closeLineDiscountDialog}>Cancel</Button>
          <Button variant="contained" onClick={saveLineDiscount}>Save</Button>
        </Box>
      </Box>
    </Modal>
      <CustomerDialog dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} />
  {modalItem && (
      <Modal
        open={showModal}
        onClose={closeItemModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {isCustomValueItem
              ? 'Enter Custom Amount'
              : isOilModal
                ? (modalMode === 'oilEdit' ? 'Update Liters' : 'Enter Liters')
                : 'Enter Consumed Units'}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {isCustomValueItem ? (
              'Provide the amount you want to add to the bill for this item.'
            ) : isOilModal ? (
              <>
                <div>Price per 1L: {Number.isFinite(modalUnitPrice) ? modalUnitPrice.toFixed(2) : '-'}</div>
                <div>
                  {hasModalNumericValue && modalLineTotal != null
                    ? `Total: ${modalLineTotal.toFixed(2)}`
                    : 'Enter liters to calculate total.'}
                </div>
              </>
            ) : (
              <>
                Base Unit Price: {modalItem.Price}{' '}
                {modalItem.ItemCategoryID === 1 ? 'per ml' : modalItem.ItemCategoryID === 18 ? '' : 'per g'}
              </>
            )}
          </Typography>
          <TextField
            autoFocus
            label={isCustomValueItem ? 'Amount' : isOilModal ? 'Liters' : 'Consumed Units'}
            type="number"
            value={consumedUnits}
            onChange={(e) => setConsumedUnits(e.target.value)}
            fullWidth
            sx={{ mt: 2 }}
            inputProps={{ min: 0, step: '0.01' }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleModalSubmit();
              }
            }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleModalSubmit}
              sx={{ mr: 1 }}
            >
              Submit
            </Button>
            <Button
              variant="outlined"
              onClick={closeItemModal}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    )}
    <Grid
      container
      spacing={2}
      style={{
        height: '100vh',
        boxSizing: 'border-box',
        paddingTop: TOP_NAV_OFFSET_PX,
        paddingLeft: 10,
        paddingRight: 10,
        paddingBottom: 10,
        marginTop: 0,
        fontFamily: 'Arial',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'row',
      }}
    >
      <Grid item xs={12} md={5} sx={{ order: { xs: 1, md: 2 } }}>
        <Paper style={{ backgroundColor: 'white', height: '100%', paddingLeft: 10, paddingRight: 10, marginBottom: 0, marginTop: 0 }}>
        <Box display="none" alignItems="center">
          {loadingItems ? <BeatLoader /> : null}
          <TextField
            id="standard-basic"
            label="Item-Code"
            variant="standard"
            onKeyPress={handleKeyPress}
            inputRef={codeRef}
            autoComplete="off"
            sx={{ flexGrow: 1, marginRight: 1 }}
          />
        

          <Button
            variant="contained"
            style={{
              backgroundColor: '#071418',
              color: 'white',
              fontWeight: 'bold',
              fontSize: 14
            }}
            onClick={returns} // Updated to open modal
          >
            Remove Bill
          </Button>

        </Box>
        <Box sx={{ display: 'flex', gap: 2, mt: 2, alignItems: 'center' }}>
          <Autocomplete
            freeSolo
            options={vehicleNoOptions}
            value={vehicleNo}
            onChange={(e, val) => {
              const vehicleVal = val || '';
              setVehicleNo(vehicleVal);
              if (vehicleVal) {
                applyCustomerHistory(vehicleVal, customerName);
              } else {
                clearVehicleDetails();
                setCustomerName('');
              }
            }}
            onInputChange={(e, val) => {
              const vehicleVal = val || '';
              setVehicleNo(vehicleVal);
              if (!vehicleVal) {
                clearVehicleDetails();
                setCustomerName('');
                return;
              }
              const matched = vehicleNoOptions.find(
                (opt) => (opt || '').toLowerCase() === vehicleVal.toLowerCase()
              );
              if (matched) {
                applyCustomerHistory(matched, customerName);
              }
            }}
            renderInput={(params) => (
              <TextField {...params} label="Vehicle No" variant="standard" autoComplete="off" />
            )}
            fullWidth
          />
          <Autocomplete
            freeSolo
            options={customerNameOptions}
            value={customerName}
            onChange={(e, val) => { setCustomerName(val || '') }}
            onInputChange={(e, val) => setCustomerName(val)}
            renderInput={(params) => (
              <TextField {...params} label="Customer Name" variant="standard" autoComplete="off" />
            )}
            fullWidth
          />
          <Button variant="outlined" size="small" onClick={() => setShowVehicleDetails(!showVehicleDetails)} >
            {showVehicleDetails ? 'Hide' : 'Show'}
          </Button>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap', alignItems: 'center' }}>
          <Button
            variant="contained"
            color="warning"
            onClick={holdCurrentBill}
            disabled={savingHoldBill || (!items.length && !treatmentItems.length)}
            style={{ fontWeight: 'bold' }}
          >
            {savingHoldBill ? 'Holding…' : 'Hold Bill'}
          </Button>
          <Button
            variant="outlined"
            onClick={openHoldBills}
            disabled={loadingHoldBill}
            style={{ fontWeight: 'bold' }}
          >
            Hold Bills ({(holdBills || []).length})
          </Button>
          {activeInvoiceNo ? (
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
              {isHoldBill ? 'HOLD' : 'Bill'}: {activeInvoiceNo}
            </Typography>
          ) : null}
          {activeInvoiceNo ? (
            <Button
              size="small"
              style={{display : 'none'}}
              variant="text"
              onClick={() => {
                const ok = window.confirm('Clear current bill?');
                if (ok) resetBill();
              }}
            >
              New Bill
            </Button>
          ) : null}
        </Box>
        <Box xs ={2} width={'100%'} sx={{ position: 'relative', mt: 2 }}>
          <Collapse
            in={showVehicleDetails}
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              zIndex: 20,
              pointerEvents: showVehicleDetails ? 'auto' : 'none',
            }}
          >
            <Paper
              elevation={6}
              sx={{
                backgroundColor: '#f7f7f7',
                p: 2,
                borderRadius: 2,
                maxHeight: '60vh',
                overflowY: 'auto',
              }}
            >
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2 }}>
                <TextField
                  label="Model"
                  value={model}
                  onChange={(e) => setModel(e.target.value)}
                  variant="standard"
                  fullWidth
                />
                <TextField
                  label="Mileage"
                  value={mileage}
                  type="number"
                  onChange={(e) => setMileage(e.target.value)}
                  variant="standard"
                  fullWidth
                />
                <TextField
                  label="Chassis Number"
                  value={chassisNumber}
                  onChange={(e) => setChassisNumber(e.target.value)}
                  variant="standard"
                  fullWidth
                />
                <Autocomplete
                  options={technicians}
                  value={selectedTechnician}
                  isOptionEqualToValue={(option, value) => option.empid === value.empid}
                  getOptionLabel={(option) => option?.EmpName || ''}
                  onChange={(e, val) => setJobDoneBy(val?.empid ?? null)}
                  renderInput={(params) => (
                    <TextField {...params} label="Job Done By (Technician)" variant="standard" />
                  )}
                />
              </Box>
            </Paper>
          </Collapse>
            {/* bill */}
            <div style={styles.billTable}>
              <table width={'100%'} style={{ width: '100%', fontFamily: 'Consolas, monospace' }}>
                <tr style={{backgroundColor : 'white',fontSize:18}} >
                  <th align='left'></th>
                  <th align='left'>Item</th>
                  <th align='center'>Qty</th>
                  <th align='center'>Price</th>
                  <th style={{textAlign : 'center'}}>Line Total</th>
                  <th style={{textAlign : 'center'}}></th>
                </tr>
                <tr style={{backgroundColor : 'White',fontSize:18}}>
                  <td align='center' colSpan={6}><hr></hr></td>
                </tr>
                {/* {items.slice().reverse().map((e,i) =>(
                  <>
                  <tr style={{fontSize:18,fontFamily : 'consolas'}}>
                    <td align='left'>{i+1}).</td>
                    <td align='left' width={100} colSpan={5}>{e.name}</td>
                  </tr>


                  <tr style={{backgroundColor : 'white',borderBottom : '1px solid black'}}>
                    <td></td>
                    <td></td>
                    <td align='center' style={{fontWeight : 'bold'}}>{ e.qty > 1 ? <button onClick={() =>{changeQtyMinus(e)}} style={{borderRadius : 50,borderWidth : 0,height:30,width:30,fontWeight : 'bold',marginRight:10,backgroundColor: '#071418',color: 'white',fontSize :18}}>-</button>:<><button style={{borderRadius : 50,borderWidth : 0,height:30,width:30,fontWeight : 'bold',marginRight:10,backgroundColor: '#071418',color: 'white',fontSize :18}}>-</button></>}{e.qty}<button onClick={() =>{changeQtyPlus(e)}} style={{borderRadius : 50,borderWidth : 0,height:30,width:30,fontWeight : 'bold',marginLeft:10,fontSize :18,backgroundColor: '#071418',color: 'white'}}>+</button></td>
                    <td align='center' style={{fontWeight : 'bold'}}>{e.Price}</td>
                    <td align='Right' onClick={handleOpenDisc} style={{fontWeight : 'bold'}}>{e.Price*e.qty}.00</td>
                    <td>
                    <img src ={require('../Assests/delete.png')} alt = 'billImage' style={styles.deleteBtn} width={20} onClick={() => {setItems(items.filter(item => item.name !== e.name)); setTotal(total-parseFloat(e.Price)); codeRef.current.focus();}}></img>
                    </td>
                    <td>
                    <img src ={require('../Assests/exchange.png')} alt = 'billImage' style={styles.deleteBtn} width={10} onClick={() => { setTotal(total-parseFloat(e.Price)); codeRef.current.focus();}}></img>
                    </td>

                  </tr>
                  </>
                ))} */}

{items.slice().reverse().map((e, i) => {
  const lineKey = getBillLineKey(e);
  const expanded = !!expandedPackages[lineKey];
  const includesLabel = e?.isPackage ? formatPackageIncludes(e.packageItems) : '';
  const remarkLines = getItemRemarkLines(e);
  const isCustomValueLine = e?.ItemCategoryID === 5022;
  const isOilLine = oilCategoryIds.includes(Number(e?.ItemCategoryID));

  return (
    <React.Fragment key={lineKey}>
      <tr style={{ fontSize: 18, fontFamily: 'Consolas' }}>
        <td align='left'>{i + 1}).</td>
        <td align='left' width={100} colSpan={5}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Tooltip title={e?.name || ''} placement="top" arrow>
              <span
                style={{
                  maxWidth: 240,
                  display: 'inline-block',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {e?.name || ''}
              </span>
            </Tooltip>
            {e?.ItemCategoryID == 5025 ? (
              <button
                onClick={() => setExpandedPackages((prev) => ({ ...prev, [lineKey]: !prev[lineKey] }))}
                style={{
                  borderRadius: 6,
                  border: '1px solid #071418',
                  backgroundColor: 'white',
                  color: '#071418',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  padding: '2px 8px',
                }}
              >
                {expanded ? '-' : '+'}
              </button>
            ) : null}
          </div>
         
        </td>
      </tr>

      {e?.ItemCategoryID == 5025 && expanded ? (
        <tr style={{ backgroundColor: 'white' }}>
          <td></td>
          <td colSpan={5} style={{ padding: '6px 0 10px 0' }}>
            {e.remarkLines ? (
              <div style={{ fontSize: 12, color: '#000', paddingLeft: 6 }}>
                 {renderRemarkLines(remarkLines, {
                  single: { fontSize: 12, color: '#000', marginTop: 4 },
                  list: { margin: '4px 0 0 18px', padding: 0, fontSize: 12, color: '#000' },
                  listItem: { margin: 0, padding: 0 },
                })}
              </div>
            ) : null}
            <div style={{ fontSize: 12, color: '#000', paddingLeft: 18 }}>
              {e?.ItemCategoryID == 5025  ? ( renderRemarkLines(remarkLines, {
                  single: { fontSize: 12, color: '#000', marginTop: 4 },
                  list: { margin: '4px 0 0 18px', padding: 0, fontSize: 12, color: '#000' },
                  listItem: { margin: 0, padding: 0 },
                })) : 'Includes: -'}
            </div>
          </td>
        </tr>
      ) : null}

      <tr style={{ backgroundColor: 'white', borderBottom: '1px dashed #000' }}>
        <td></td>
        <td align='center'>
          {isCustomValueLine ? (
            <span>-</span>
          ) : (
            <>
              <div>
                {e.discountedPrice ? (
                  <span>
                    <span style={{ textDecoration: 'line-through', color: '#888', marginRight: 6 }}>{parseFloat(e.originalPrice || e.Price).toFixed(2)}</span>
                    <span style={{ color: '#000' }}>{parseFloat(e.discountedPrice).toFixed(2)} <small></small></span>
                  </span>
                ) : (
                  <span style={{ color: '#000' }}>{parseFloat(e.originalPrice || e.Price).toFixed(2)}</span>
                )}
              </div>
              {parseFloat(e.lineDiscount || 0) > 0 ? (
                <div style={{ fontSize: 12, color: '#000' }}>
                  - Rs. {parseFloat(e.lineDiscount || 0).toFixed(2)} 
                </div>
              ) : null}
            </>
          )}
        </td>
        <td align='center'>
          {isCustomValueLine ? (
            <span>-</span>
          ) : isOilLine ? (
            <>
              <button
                onClick={() => openOilEditModal(e)}
                style={{
                  borderRadius: 6,
                  border: '1px solid #071418',
                  backgroundColor: '#071418',
                  color: 'white',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  padding: '2px 10px',
                  marginRight: 10,
                }}
              >
                Edit
              </button>
              <span style={{ fontWeight: 'bold' }}>{formatLiters(e.qty)} L</span>
            </>
          ) : (
            <>
              {e.qty > 1 ? (
                <button
                  onClick={() => { changeQtyMinus(e) }}
                  style={{
                    borderRadius: 50, borderWidth: 0, height: 30, width: 30,
                    fontWeight: 'bold', marginRight: 10, backgroundColor: '#071418',
                    color: 'white', fontSize: 18
                  }}>-</button>
              ) : (
                <button style={{
                  borderRadius: 50, borderWidth: 0, height: 30, width: 30,
                  fontWeight: 'bold', marginRight: 10, backgroundColor: '#071418',
                  color: 'white', fontSize: 18
                }}>-</button>
              )}
              {e.qty}
              <button
                onClick={() => { changeQtyPlus(e) }}
                style={{
                  borderRadius: 50, borderWidth: 0, height: 30, width: 30,
                  fontWeight: 'bold', marginLeft: 10, fontSize: 18, backgroundColor: '#071418',
                  color: 'white'
                }}>+</button>
            </>
          )}
        </td>
        <td align='Right'>
          {Math.max((parseFloat(e.Price) * e.qty) - (parseFloat(e.lineDiscount || 0)), 0).toFixed(2)}
        </td>
        <td align='center' style={{ display: 'flex', justifyContent: 'center' }}>
          <div
            size="small"
            variant="outlined"
            onClick={() => openLineDiscountDialog(e)}
            style={{
              color: parseFloat(e.lineDiscount || 0) > 0 ? '#000' : undefined,
              borderColor: parseFloat(e.lineDiscount || 0) > 0 ? '#000' : undefined,
              backgroundColor: 'transparent'
            }}
          >
            %
          </div>
          <img
            src={require('../Assests/delete.png')}
            alt='billImage'
            style={{ ...styles.deleteBtn, filter: 'none' }}
            width={20}
            onClick={() => {
              setItems(items.filter(item => item.name !== e.name));
              setTotal(total - (e.Price * e.qty));  // Remove item total from total
              codeRef.current.focus();
            }}
          />
        </td>
        {/* <td>
          <img
            src={require('../Assests/exchange.png')}
            alt='billImage'
            style={styles.deleteBtn}
            width={10}
            onClick={() => {
              setItems(items.map(item => {
                if (item.name === e.name) {
                  if (!item.name.includes('- ex')) {
                    return { 
                      ...item, 
                      name: `${item.name} - ex`, 
                      Price: -Math.abs(item.Price)
                    };
                  }
                }
                return item;
              }));
              codeRef.current.focus();

            }}
          />
        </td> */}
      </tr>
    </React.Fragment>
  );
})} 
              </table> 
            </div>
        <div style={{fontSize: 40,color: 'Black',fontWeight : 'bold',marginTop:0}}>
          <div>
            Total  Rs.<label style={{ color: 'gray' }}>  {total}.00</label><br></br>
          </div>
          {/* <div style={{ fontSize: 30, color: 'gray' }}>
            Discount Rs.<label style={{ color: 'gray' }}>  {discount}.00</label><br></br>
          </div> */}
         </div>
         <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '5px' }}>
    {/* Payment Button */}
    {items.length > 0 && total >= 0 ? (
      <button 
        style={{
          width: '100%', fontSize: 30, height: 65, fontWeight: 'bold',
          backgroundColor: '#00B912', borderRadius: 5, borderWidth: 0,
          color: "white", display: 'flex', justifyContent: 'center', alignItems: 'center'
        }} 
        onClick={handleOpen}
      >
        Pay Rs.{finalTotal.toFixed(2)}
        <img src={require('../Assests/cash.png')} alt='billImage' style={{ width: 45, marginLeft: 10 }} />
      </button>
    ) : (
      <button 
        style={{
          width: '100%', fontSize: 30, height: 65, fontWeight: 'bold',
          backgroundColor: 'gray', borderRadius: 5, borderWidth: 0,
          color: "white"
        }}
      >
        Pay Rs.{finalTotal.toFixed(2)}
        <img src={require('../Assests/cash.png')} alt='billImage' style={{ width: 45, marginLeft: 10, marginTop: -10 }} />
      </button>
    )}

    
  </div>
      </Box>
        </Paper>
      </Grid>
      {/* <Grid item xs = {12} md={8}>
        <Paper style={{ backgroundColor: 'white', height: '100%',marginRight:10 , marginTop : 50}}>
          <TableTabs bill = {addToBill}/>
        </Paper>
      </Grid> */}

    <Grid item xs={12} md={7} >
      <Paper style={{ backgroundColor: "white", height: "100%", marginTop: 0 ,backgroundColor : '#ffffffff'}}>
        <TableTabs key={refreshKey} bill={addToBill} />
      </Paper>
    </Grid>

    </Grid>

    
  <div>
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={styles.style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Payment Methods
        </Typography>
        
        {/* Payment Method Selection */}
        <div>
          <RadioGroup
            row
            name="paymentMethod"
            onChange={(e) => setPaymentMethos(e.target.value)}
            value={paymentMethod}
          >
            <FormControlLabel value="Cash" control={<Radio />} label="Cash" />
            <FormControlLabel value="Card" control={<Radio />} label="Card" />
          </RadioGroup>
        </div>

      
        {paymentMethod === 'Cash' ? (
          <div
            style={{
              margin: 10,
              display: 'flex',
              height: '35vh',
              flexDirection: 'column',
              justifyContent: 'space-around',
              alignItems: 'flex-start',
            }}
          >
            <Typography id="modal-modal-description" style={{ fontSize: 35, color: 'green' }}>
              Total : Rs.{finalTotal.toFixed(2)}
            </Typography>

            {/* Balance Calculation */}
            <Typography
              id="modal-modal-description"
              style={{
                fontSize: 25,
                color: cash - finalTotal < 0 ? 'red' : 'blue',
              }}
            >
              {cash - finalTotal < 0 ? (
                <>Balance : -- --</>
              ) : (
                <>Balance : Rs. {cash - finalTotal}.00</>
              )}
              <hr />
            </Typography>

            {/* Cash Input */}
            <TextField
              id="standard-basic"
              onChange={(e) => setCash(e.target.value)}
              type="number"
              autoComplete="off"
              onKeyDown={(e) => {
                if (e.key === 'Enter' && cash - finalTotal >= 0) {
                  toPrint();
                }
              }}
            />

            {/* Print Button */}
            <div style={{ fontSize: 25, alignItems: 'center' }}></div>
            {loading && paymentMethod === 'Cash' ? (
              <center><BeatLoader color="#28968E" /></center>
            ) : (
              <>
                {cash - finalTotal < 0 ? (
                  <Button
                    style={{
                      width: '100%', height: 80, fontSize: 30, marginTop: 15, 
                      fontWeight: 'bold', backgroundColor: '#A7A7A7', 
                      borderRadius: 5, color: 'black',
                    }}
                    disabled
                    variant="contained"
                    startIcon={<PrintIcon style={{ fontSize: 40 }} />}
                  >
                    PRINT
                  </Button>
                ) : (
                  <Button
                    style={{
                      width: '100%', height: 80, fontSize: 30, marginTop: 15, 
                      fontWeight: 'bold', backgroundColor: '#0029FF', 
                      borderRadius: 5, color: 'white',
                    }}
                    onClick={toPrint}
                    variant="contained"
                    startIcon={<PrintIcon style={{ fontSize: 40 }} />}
                  >
                    PRINT
                  </Button>
                )}
              </>
            )}
          </div>
        ) : (
          <div
            style={{
              margin: 10,
              display: 'flex',
              height: '20vh',
              flexDirection: 'column',
              justifyContent: 'space-around',
            }}
          >
            <Typography id="modal-modal-description" style={{ fontSize: 35, color: 'green' }}>
              Total : Rs.{finalTotal.toFixed(2)}
            </Typography>

            {loading ? (
              <center><BeatLoader color="#28968E" /></center>
            ) : (
              <Button
                style={{
                  width: '100%', height: 80, fontSize: 30, marginRight: 5, 
                  fontWeight: 'bold', backgroundColor: '#0029FF', 
                  borderRadius: 5, color: 'white',
                }}
                onClick={toPrint}
                variant="contained"
                startIcon={<PrintIcon style={{ fontSize: 40 }} />}
              >
                PRINT
              </Button>
            )}
          </div>
        )}
      </Box>
    </Modal>
  </div>



      <div>
      <Modal
        open={openDisc}
        onClose={handleCloseDisc}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        >
        <Box sx={styles.style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Discount Amount :
          </Typography>
          <br></br>
          <br></br>

          <TextField
            id="standard-basic"
            label="Discount in Rs."
            variant="standard"
            onChange={(e) => setDiscount(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                addDiscount();
              }
            }}
            type="number"
            autoComplete="off"
          />
          <br></br>
          <br></br>

          <div style={{ fontSize: 20 }}>
            <br></br>
            <br></br>
            <Button variant="outlined" onClick={() => addDiscount()} style={{ width: 300 }}>
              Add Discount
            </Button>
          </div>
        </Box>

      </Modal>
      {/* printingBill */}
      <div style={{ display: 'none' }}>
        <div
          ref={printsRef}
          style={{
            width: '210mm',
            height: '297mm',
            minHeight: '297mm',
            padding: '12mm',
            paddingBottom: '27mm',
            backgroundColor: '#fff',
            color: '#000',
            fontFamily: 'Consolas, monospace',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            gap: '10px'
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <img src={require('../Assests/billLogo.png')} alt='' width={120} style={{ objectFit: 'contain',filter: 'grayscale(100%)' }} />
            <div style={{ textAlign: 'center', flex: 1, margin: '0 20px' }}>
              <div style={{ fontSize: '24px', letterSpacing: '1px' }}>U.K. AUTO TECH</div>
              <div style={{ fontSize: '16px', letterSpacing: '1px' }}>Vehicle Repairing and Service</div>
              <hr></hr>
              <div style={{ fontSize: '9px', marginTop: '4px' }}>
                Hybrid Repairs, EFI, Common Rail Vehicles, SRS Air Bag, ABS System, Vehicle Scanning, Running Repairs &amp; Engine Repairs, Brand New &amp; Recondition Spare Parts &amp; Lubricants
                <br />
              </div>
                <div style={{ fontSize: '12px', marginTop: '4px' }}>

                {BRAND.addressLine1 ? `${BRAND.addressLine1}, ` : ''}{BRAND.addressLine2} <br></br>  {BRAND.telephone}
                </div>
            </div>
            <div style={{ fontSize: '18px' }}>INVOICE</div>
          </div>
          <hr />
          <div style={{ fontSize: PRINT_BILL_BODY_FONT_SIZE_PX }}>
            <div style={{ textAlign: 'center' }}>Invoice No: {invoiceNumber}</div>
            <hr />
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '100px' }}>
              <div style={{ flex: 1 }}>
                <div><span>Customer:</span> {customerName || '-'}</div>
                <div><span>Vehicle Model:</span> {model || '-'}</div>
                <div><span>Chassis Number:</span> {chassisNumber || '-'}</div>
              </div>
              <div style={{ flex: 1 }}>
                <div><span>Vehicle No:</span> {vehicleNo || '-'}</div>
                <div><span>Mileage:</span> {mileage || '-'} km</div>
                <div><span>Date:</span> {`${year}-${month}-${day}`}</div>
              </div>
            </div>
            <hr />
	            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
	              <thead>
	                <tr>
	                  {['No', 'Description', 'QTY', 'Amount', 'Discount', 'Total'].map((head) => (
	                    <th
	                      key={head}
	                      style={{ border: 'none', padding: '6px', textAlign: head === 'Description' ? 'left' : head === 'QTY' ? 'center' : 'right', fontWeight: 'normal' }}
	                    >
	                      {head}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {printableItems?.map((e, i) => {
                  const isCustomValueLine = e?.ItemCategoryID === 5022;
                  const qty = parseFloat(e.qty) || parseFloat(e.units) || 1;
                  const originalPrice = parseFloat(e.originalPrice ?? e.unitPrice ?? e.sellingPrice ?? e.Price ?? e.totalPrice ?? 0);
                  const discountedPrice = e.discountedPrice ? parseFloat(e.discountedPrice) : null;
	                  const effectivePrice = discountedPrice && discountedPrice > 0 ? discountedPrice : originalPrice;
	                  const lineDiscount = parseFloat(e.lineDiscount || 0);
	                  const unitPriceDiscount =
	                    discountedPrice && discountedPrice > 0
	                      ? Math.max(originalPrice - discountedPrice, 0)
	                      : 0;
	                  const discountAmount = Math.max(unitPriceDiscount * qty + lineDiscount, 0);
	                  const customValuePrice = parseFloat(e.Price ?? e.totalPrice ?? e.originalPrice ?? 0);
	                  const lineTotal = Math.max(
	                    (isCustomValueLine ? customValuePrice : qty * effectivePrice) - lineDiscount,
	                    0
	                  );
                  const packageIncludes = e?.isPackage ? formatPackageIncludes(e.packageItems) : '';
                  const remarkLines = getItemRemarkLines(e);
                  return (
                    <React.Fragment key={`${e.name}-${i}`}>
                      <tr>
                        <td style={{ border: 'none', padding: '6px', textAlign: 'center' }}>{i + 1}</td>
                        <td style={{ border: 'none', padding: '6px' }}>
                          <div>{e.ItemCategoryID === 5000 ? 'Advance' : e.name}</div>
                          {e?.ItemCategoryID == 5025 ? (


                          renderRemarkLines(remarkLines, {
                            single: { fontSize: Math.max(PRINT_BILL_BODY_FONT_SIZE_PX - 2, 8), marginTop: 4 },
                            list: { margin: '4px 0 0 16px', padding: 0, fontSize: Math.max(PRINT_BILL_BODY_FONT_SIZE_PX - 2, 8) },
                            listItem: { margin: 0, padding: 0 },
                          })
                          ) : (<></>) }
                        </td>
                        <td style={{ border: 'none', padding: '6px', textAlign: 'center' }}>
                          {isCustomValueLine ? '' : qty}
                        </td>
	                        <td style={{ border: 'none', padding: '6px', textAlign: 'right' }}>
	                          {isCustomValueLine ? (
	                            ''
	                          ) : (
	                            <span>{originalPrice.toFixed(2)}</span>
	                          )}
	                        </td>
	                        <td style={{ border: 'none', padding: '6px', textAlign: 'right' }}>
	                          {isCustomValueLine ? (
	                            ''
	                          ) : discountAmount > 0 ? (
	                            <span>{discountAmount.toFixed(2)}</span>
	                          ) : (
	                            ''
	                          )}
	                        </td>
	                        <td style={{ border: 'none', padding: '6px', textAlign: 'right' }}>{lineTotal.toFixed(2)}</td>
	                      </tr>
	                      {e?.isPackage && packageIncludes ? (
	                        <tr>
	                          <td style={{ border: 'none', padding: 0 }}></td>
	                          <td colSpan={5} style={{ border: 'none', padding: '0 6px 6px 22px', color: '#000' }}>
	                            {packageIncludes}
	                          </td>
	                        </tr>
	                      ) : null}
                    </React.Fragment>
                  );
	                })}
	                <tr>
	                  <td colSpan={5} style={{ border: 'none', padding: '6px', textAlign: 'right' }}>Total</td>
	                  <td style={{ border: 'none', padding: '6px', textAlign: 'right' }}>{finalTotal.toFixed(2)}</td>
	                </tr>
	              </tbody>
	            </table>
            <div style={{ color: '#000' }}>Discount: Rs. {totalDiscountSum.toFixed(2)}</div>
            <hr />
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  {['Payment Method', 'Amount Paid', 'Balance'].map((head) => (
                    <th key={head} style={{ border: 'none', padding: '6px', textAlign: 'left', fontWeight: 'normal' }}>{head}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: 'none', textAlign: 'left', paddingLeft: '6px' }}>{metaData?.Method}</td>
                  <td style={{ border: 'none', textAlign: 'left', paddingLeft: '6px' }}>
                    {metaData?.Method === 'Card' ? finalTotal.toFixed(2) : parseFloat(metaData?.Amount || 0).toFixed(2)}
                  </td>
                  <td style={{ border: 'none', textAlign: 'left', paddingLeft: '6px' }}>
                    {metaData?.Method === 'Card' ? '0.00' : (parseFloat(metaData?.Amount || 0) - finalTotal).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: 'auto', pageBreakInside: 'avoid', pageBreakBefore: 'avoid' }}>
            <hr />
            <div style={{ fontFamily: 'consolas', display: 'flex', justifyContent: 'space-around', fontSize: PRINT_BILL_BODY_FONT_SIZE_PX }}>
              <div>
                <span>Bank Account Details</span>
                <div>Account Name: {BRAND.name}</div>
              </div>
              <div>
                BOC - Kirindiwela : 000000000000 <br></br>
                HNB - Kirindiwela : 000000000000
              </div>
            </div>
            <hr />
            <div style={{ textAlign: 'center', fontSize: 10 }}>
              <div>Thank you. Come again.</div>
              <div>Software by CC Software Solutions | 077 0832 340</div>
            </div>
          </div>
        </div>
      </div>

      {/* Return Bill */}
      <div style={{ display: 'none' }}>
        <div ref={ReturnprintsRef} style={printTheme.page}>
          <div style={printTheme.header}>
            <div style={printTheme.brandBlock}>
              <span style={printTheme.badge}>Return Invoice</span>
              <img src={require('../Assests/billLogo.png')} alt='' width={140} style={{ marginBottom: 6 }} />
              <div style={printTheme.brandName}>{BRAND.name}</div>
              <div style={printTheme.brandMeta}>
                {BRAND.addressLine1 ? `${BRAND.addressLine1}, ` : ''}{BRAND.addressLine2}
                <br />
                Tel: {BRAND.telephone}
              </div>
            </div>
            <div style={printTheme.metaBlock}>
              <div style={printTheme.metaRow}><span>Invoice No</span><span>{updateBillNo}</span></div>
              <div style={printTheme.metaRow}><span>Return Date</span><span>{`${year}-${month}-${day}`}</span></div>
              <div style={printTheme.metaRow}><span>Time</span><span>{`${hours}:${minutes}`}</span></div>
              <div style={{ ...printTheme.metaRow, borderBottom: 'none' }}><span>Cashier</span><span>{JSON.parse(sessionStorage.getItem(BRAND.sessionStorageKey))?.username}</span></div>
            </div>
          </div>

          <table style={printTheme.table}>
            <thead>
              <tr>
                <th style={{ ...printTheme.th, width: '6%' }}>#</th>
                <th style={{ ...printTheme.th, width: '46%' }}>Item</th>
                <th style={{ ...printTheme.th, width: '18%' }}>Price (Rs)</th>
                <th style={{ ...printTheme.th, width: '12%' }}>Qty</th>
                <th style={{ ...printTheme.th, width: '14%' }}>Line Total (Rs)</th>
              </tr>
            </thead>
            <tbody>
              {updatedBillItems
                ?.filter((e) => e.qty > 0)
                .map((e, i) => {
                  const qty = parseFloat(e.qty) || 0;
                  const originalPrice = parseFloat(e.unitPrice) || 0;
                  const discountedPrice = e.discountedPrice ? parseFloat(e.discountedPrice) : null;
                  const effectivePrice = discountedPrice && discountedPrice > 0 ? discountedPrice : originalPrice;
                  const lineTotal = qty * effectivePrice;
                  return (
                    <tr key={`${e.item_name}-${i}`} style={i % 2 === 0 ? printTheme.rowAlt : {}}>
                      <td style={printTheme.td}>{i + 1}</td>
                      <td style={printTheme.td}>{e.item_name}</td>
                      <td style={{ ...printTheme.td, textAlign: 'right' }}>
                        {discountedPrice ? (
                          <>
                            <span style={{ textDecoration: 'line-through', color: '#000000ff', marginRight: 6 }}>{originalPrice.toFixed(2)}</span>
                            <span>{discountedPrice.toFixed(2)}</span>
                            <small style={{ display: 'block', color: '#000000ff' }}>(Discounted Price)</small>
                          </>
                        ) : (
                          <span>{originalPrice.toFixed(2)}</span>
                        )}
                      </td>
                      <td style={{ ...printTheme.td, textAlign: 'right' }}>{qty}</td>
                      <td style={{ ...printTheme.td, textAlign: 'right' }}>{lineTotal.toFixed(2)}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          <div style={printTheme.totals}>
            <div style={printTheme.totalRow}>
              <span>Gross Total</span>
              <span>Rs. {updatedBillTotal.toFixed(2)}</span>
            </div>
            <div style={{ ...printTheme.totalRow, ...printTheme.grandTotal, borderBottom: 'none' }}>
              <span>Refund Due</span>
              <span>Rs. {(updatedBillTotal - (updateBillmetaData?.Discount || 0)).toFixed(2)}</span>
            </div>
          </div>

          <div style={printTheme.footer}>
            <div style={{ color: '#000' }}>Items returned are subject to inspection.</div>
            <div>Thank you. Come again.</div>
            <div style={{ marginTop: '6px' }}>Software by CC Software Solutions | 077 0832 340</div>
          </div>
        </div>
      </div>

{/* Hold Bills Modal */}
      <Modal
        open={holdModalOpen}
        onClose={closeHoldBills}
        aria-labelledby="hold-modal-title"
        aria-describedby="hold-modal-description"
      >
        <Box sx={{ ...styles.style, width: 900, maxWidth: '95vw' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
            <Typography id="hold-modal-title" variant="h6" component="h2">
              Hold Bills
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Button variant="outlined" onClick={fetchHoldBills} disabled={loadingHoldBill}>
                Refresh
              </Button>
              <Button variant="outlined" onClick={closeHoldBills}>
                Close
              </Button>
            </Box>
          </Box>

          <Box sx={{ mt: 2 }}>
            <TextField
              label="Search (Invoice / Vehicle / Customer / Model)"
              value={holdSearch}
              onChange={(e) => setHoldSearch(e.target.value)}
              fullWidth
              variant="standard"
              autoComplete="off"
            />
          </Box>

          <Box sx={{ mt: 2 }}>
            <TableContainer component={Paper} style={{ maxHeight: 420, overflowY: 'auto' }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: 'bold' }}>Invoice No</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Vehicle No</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Customer</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Model</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }} align="right">Total</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Date</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }} align="right">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(filteredHoldBills || []).map((row) => {
                    const isSelected = selectedHoldBill?.inv_no === row?.inv_no;
                    return (
                      <TableRow
                        key={row.inv_no}
                        hover
                        selected={isSelected}
                        onClick={() => setSelectedHoldBill(row)}
                        onDoubleClick={() => loadHoldBill(row)}
                        style={{ cursor: 'pointer' }}
                      >
                        <TableCell>{row.inv_no}</TableCell>
                        <TableCell>{row.Vehicle_no || '-'}</TableCell>
                        <TableCell>{row.Customer_name || '-'}</TableCell>
                        <TableCell>{row.model || '-'}</TableCell>
                        <TableCell align="right">{parseFloat(row.net_total || 0).toFixed(2)}</TableCell>
                        <TableCell>{row.inv_date || '-'}</TableCell>
                        <TableCell align="right">
                          <Button
                            size="small"
                            variant="contained"
                            onClick={(e) => {
                              e.stopPropagation();
                              loadHoldBill(row);
                            }}
                            disabled={loadingHoldBill}
                          >
                            Load
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}

                  {!filteredHoldBills?.length && (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        No hold bills found.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {loadingHoldBill && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <BeatLoader color="#071418" />
              </Box>
            )}
          </Box>
        </Box>
      </Modal>

{/* Return Model */}
      <Modal
        open={returnModalOpen}
        onClose={handleReturnClose}
        aria-labelledby="return-modal-title"
        aria-describedby="return-modal-description"
      >
        <Box sx={styles.style}>
          <Typography id="return-modal-title" variant="h6" component="h2">
            Return Bill Details for {BRAND.name}
          </Typography>
         
            <div>
              <Grid container spacing={1}>
                <Grid xs = {12} md = {12}>
                  <div style={{ display: 'flex', justifyContent: 'space-between',margin : 20 }}>

                  <Autocomplete
                    options={returnBills} // Pass the entire array of bill objects
                    getOptionLabel={(option) => option.inv_no || ''} // Extract 'inv_no' for display
                    value={
                      returnBills.find((bill) => bill.inv_no === returnBillNo) || returnBillNo || ''
                    } // Set the value to the selected bill object or the entered string
                    onChange={(event, newValue) => {
                      if (typeof newValue === 'string') {
                        // User typed a bill number
                        setReturnBillNo(newValue);
                      } else if (newValue && newValue.inv_no) {
                        // User selected a bill from the dropdown
                        setReturnBillNo(newValue.inv_no);
                      } else {
                        // Handle cases like clearing the input
                        setReturnBillNo('');
                      }
                    }}
                    freeSolo // Allow users to enter values not present in the list
                    renderOption={(props, option) => (
                      <li {...props} key={option.inv_no}>
                        {option.inv_no}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Enter Bill Number"
                        variant="standard"
                        fullWidth
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            handleReturnSubmit();
                          }
                        }}
                      />
                    )}
                    noOptionsText="No matching bill numbers"
                    style={{ width: 300 }}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleReturnSubmit}
             
                    style={{marginLeft: 20,fontSize:15}}
                    >
                    Search
                  </Button>
                    </div>
                    <hr></hr>

                    <Grid xs = {12} md = {12}>
                        <div>
                          {/* Display the bill details */}
                          <TableContainer
      component={Paper}
      style={{
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        height: 400, // Set the maximum height for the container
        overflowY: 'auto',  // Enable vertical scrolling
      }}
    >
      <Table stickyHeader style={{ minWidth: 650 }} >
        <TableHead>
          <TableRow style={{ backgroundColor: '#071418' }}>
            <TableCell style={{ color: 'White', fontWeight: 'bold',backgroundColor : '#071418' }}>Invoice No</TableCell>
            <TableCell style={{ color: 'White', fontWeight: 'bold',backgroundColor : '#071418' }}>Item Name</TableCell>
            <TableCell style={{ color: 'White', fontWeight: 'bold',backgroundColor : '#071418' }}>Updated Qty</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {returnBillDetails?.map((e, i) => (
            <TableRow key={i} style={i % 2 === 0 ? { backgroundColor: '#f9f9f9' } : {}}>
              <TableCell>{e.billNo}</TableCell>
              <TableCell>{e.item_name}</TableCell>

              {/* Editable qty field */}
              <TableCell>
              {e.qty}
                {/* <input
                  type="number"
                  value={e.returnQty !== undefined ? e.returnQty : e.qty}  // Default to e.qty if no returnQty is set
                  min="0"
                  max={e.qty}  // Prevent the return quantity from exceeding the total purchased quantity
                  onChange={(event) => handleQtyChange(i, event.target.value)}
                  style={{ width: '50px', textAlign: 'center', height: 30, fontSize: 20 }}
                /> */}
              </TableCell>

            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
                        </div>
                    </Grid>



                          {/* <Button
                            variant="contained"
                            color="primary"
                            onClick={toReturnPrint}
                            sx={{ mt: 2 }}
                            fullWidth
                            style={{fontSize:15,fontWeight : 'bold'}}
                          >
                            Reprint Bill 
                          </Button> */}
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={UpdatedTheDeleteBill}
                            sx={{ mt: 2 }}
                            fullWidth
                            style={{fontSize:15,fontWeight : 'bold'}}
                          >
                            Remove BILL 
                          </Button>
                </Grid>

                

              </Grid>
            </div>
         
         
          {returnLoading && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <BeatLoader color="#071418" />
            </Box>
          )}
        </Box>
      </Modal>

    </div>
    </>
  )
}

export default Billing
